import React from 'react';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';

/**
 * This function renders the Cookie Policy page
 * @component CookiePolicyPage
 * @return {Component} CookiePolicyPage component
 */
export default function CookiePolicyPage() {
  return (
    <Card style={{
      padding: '50px',
      width: '70%',
      margin: '30px auto',
    }}>
      <div>
        <Typography variant="h6" gutterBottom>
          <h1>Cookie Policy</h1>
        </Typography>
        <Divider />
        <p style={{fontSize: '16px'}}>
            ...
        </p>
      </div>
    </Card>
  );
}
